import React from 'react';
import classNames from 'classnames/bind';
import styles from './VouchersModal.module.scss';
import { Row, Form, Col, Popover, Button } from 'antd';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import moment from 'moment';
import Image from '../Image';
import { getNumberWithCommas } from '~/utils';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import config from '~/config';
const cx = classNames.bind(styles);

const VouchersModal = ({
    voucherList,
    voucherSelected,
    setVoucherSelected,
    setVoucherSubmit,
    setIsShowVouchers,
    totalPriceProductOrder,
    updateInfoSchedule,
}) => {
    const navigate = useNavigate();

    const handleSelectVoucher = (item) => {
        if (item.id !== voucherSelected.id && totalPriceProductOrder >= item?.minimum_price) {
            setVoucherSelected(item);
        } else {
            setVoucherSelected({});
        }
    };

    const handleSubmitVoucher = () => {
        setIsShowVouchers(false);
        setVoucherSubmit(voucherSelected);
        localStorage.setItem('voucherSubmit', JSON.stringify(voucherSelected));
    };

    return (
        <Form>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    Discount code
                </Row>
            </Form.Item>

            <div className={cx('vouchers_container')}>
                {voucherList?.length ? (
                    voucherList
                        .filter((x) => !x.isUsed && x.amount_used < x.amount)
                        ?.map((item) => {
                            return (
                                <Row
                                    key={item?.id}
                                    onClick={() => handleSelectVoucher(item)}
                                    className={cx('item_voucher', {
                                        item_voucher_selected: item.id === voucherSelected.id,
                                        item_voucher_disable: totalPriceProductOrder < item?.minimum_price,
                                    })}
                                >
                                    <Row style={{ width: '100%' }}>
                                        <Col span={24} className={cx('item_container')}>
                                            <Col className={cx('thumbnail')}>
                                                <Image src={item?.thumbnail || IMAGES.ImagePlaceholder} />
                                            </Col>
                                            <Col span={15} className={cx('content')}>
                                                <Row className={cx('name')}>{item?.name}</Row>
                                                <Row className={cx('description')}>{item?.description}</Row>
                                                <Row className={cx('expired')}>
                                                    HSD: {moment(item?.expiry, 'x').format('DD/MM/YYYY')}
                                                    <a
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => {
                                                            navigate(`/thong-tin-voucher/${item.id}`);
                                                            updateInfoSchedule();
                                                        }}
                                                        className={cx('detail')}
                                                    >
                                                        <span className={cx('btn_detail')}>i</span>{' '}
                                                        <span>Details</span>
                                                    </a>
                                                </Row>
                                            </Col>
                                            <Col xs={2} className={cx('right_select')}>
                                                <Row align="middle" justify="end">
                                                    <div
                                                        className={cx('circle', {
                                                            circle_selected: item.id === voucherSelected.id,
                                                        })}
                                                    >
                                                        <img src={SVGS.IconArrowChecked} alt="" />
                                                    </div>
                                                </Row>
                                            </Col>
                                        </Col>
                                    </Row>
                                    <Col xs={24}>
                                        {totalPriceProductOrder < item?.minimum_price ? (
                                            <Row className={cx('notification')} align="middle">
                                                <img src={SVGS.IconNotification} alt="" />
                                                <span>
                                                    Buy more{' '}
                                                    {getNumberWithCommas(item?.minimum_price - totalPriceProductOrder)}{' '}
                                                    d to use the voucher
                                                </span>
                                            </Row>
                                        ) : (
                                            ''
                                        )}
                                    </Col>
                                </Row>
                            );
                        })
                ) : (
                    <Row justify="center">There are currently no vouchers</Row>
                )}
            </div>
            <Form.Item style={{ marginTop: '40px' }}>
                <Row>
                    <div onClick={handleSubmitVoucher} className={cx('btn_submit')}>
                        Apply
                    </div>
                </Row>
            </Form.Item>
        </Form>
    );
};

export default VouchersModal;
